import { CaseDraftRow } from './types-store';

export const ACTION = {
  REQUEST_LOAD_DRAFTS: 'CASE_DRAFTS_TABLE:REQUEST_LOAD_DRAFTS',
  RECEIVE_LOAD_DRAFTS: 'CASE_DRAFTS_TABLE:RECEIVE_LOAD_DRAFTS',
  FAIL_LOAD_DRAFTS: 'CASE_DRAFTS_TABLE:FAIL_LOAD_DRAFTS',
  REQUEST_DELETE_DRAFT: 'CASE_DRAFTS_TABLE:REQUEST_DELETE_DRAFT',
  RECEIVE_DELETE_DRAFT: 'CASE_DRAFTS_TABLE:RECEIVE_DELETE_DRAFT',
  FAIL_DELETE_DRAFT: 'CASE_DRAFTS_TABLE:FAIL_DELETE_DRAFT'
};

export class RequestLoadDrafts {
  public type: string = ACTION.REQUEST_LOAD_DRAFTS;
}

export class ReceiveLoadDrafts {
  public type: string = ACTION.RECEIVE_LOAD_DRAFTS;
  constructor(public rows: CaseDraftRow[]) {}
}

export class FailLoadDrafts {
  public type: string = ACTION.FAIL_LOAD_DRAFTS;
}

export class RequestDeleteDraft {
  public type: string = ACTION.REQUEST_DELETE_DRAFT;
}

export class ReceiveDeleteDraft {
  public type: string = ACTION.RECEIVE_DELETE_DRAFT;
  constructor(public draftId: number) {}
}

export class FailDeleteDraft {
  public type: string = ACTION.FAIL_DELETE_DRAFT;
}
